<div
  class="excel-wrapper"
  [ngClass]="{ disabled: isDisabled }"
  (click)="sendExportExcelSignal()"
>
  <img
    class="excel-icon"
    alt="excel"
    [src]="isDisabled ? IMAGES.EXCEL_INACTIVE : IMAGES.EXCEL_ACTIVE"
  />
  <div class="text">
    {{ DISP_CONSTS.BUTTON_TEXT }}
  </div>
</div>
